module.exports = __webpack_public_path__ + "img/stock4.a0308d6a.png";